<template>
  <ValidationObserver ref="vee-password">
    <b-row class="justify-content-center">
      <b-col cols="12" sm="7" class="mb-3">
        <label>Veuillez définir un mot de passe :</label>
        <ValidationProvider
          v-slot="{ errors, classes }"
          :name="'password'"
          rules="required|min:4|confirmed:confirm"
          vid="confirm"
          tag="div"
          mode="passive"
        >
          <div class="password-input-wrapper">
            <b-input
              autofocus
              :value="object.password"
              :type="inputType1"
              @input="$emit('updateObject', 'password', $event)"
            />
            <font-awesome-icon
              :icon="inputType1 == 'password' ? 'eye-slash' : 'eye'"
              @click="inputType1 == 'password' ? (inputType1 = 'text') : (inputType1 = 'password')"
            />
          </div>

          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col cols="12" sm="7">
        <label>Vérification mot de passe :</label>
        <!-- You can use vid or name to specify a targetable field -->
        <ValidationProvider
          v-slot="{ errors, classes }"
          :name="'passwordConfirm'"
          rules="confirmed:confirm"
          tag="div"
          mode="passive"
        >
          <div class="password-input-wrapper">
            <b-input
              :value="object.passwordConfirm"
              :type="inputType2"
              @input="$emit('updateObject', 'passwordConfirm', $event)"
            />
            <font-awesome-icon
              :icon="inputType2 == 'password' ? 'eye-slash' : 'eye'"
              @click="inputType2 == 'password' ? (inputType2 = 'text') : (inputType2 = 'password')"
            />
          </div>
          <span :class="classes">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-col>
      <b-col cols="12" sm="7">
        <b-row class="mt-5 mb-2">
          <b-col cols="auto" class="pr-0">
            <font-awesome-icon icon="info-circle" />
          </b-col>
          <!-- ???: FIXME: .. -->
          <b-col class="pl-2"> Lorem ipsum dolor sit amet, consectetur adipiscing elit </b-col>
        </b-row>
      </b-col>
    </b-row>
  </ValidationObserver>
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      inputType1: "password",
      inputType2: "password",
    };
  },
};
</script>
